"use strict";

/**
 * @generated SignedSource<<61f2462c77c1cd16efe2f4ddb14f3faf>>
 * @relayHash 31f7b0f6e764b041377577952e3e3e52
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46281cf941d0f3a0f285e5edec78b3d1c5c1f0a8399a5d802f793685e46ee2cf

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "supplierSlug"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "slug",
      "variableName": "supplierSlug"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v3 = {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "audience",
          "value": "SUPPLIER"
        }],
        "concreteType": "ConfigurationWarning",
        "kind": "LinkedField",
        "name": "configurationWarnings",
        "plural": true,
        "selections": [v2 /*: any*/],
        "storageKey": "configurationWarnings(audience:\"SUPPLIER\")"
      }],
      "type": "Supplier",
      "abstractKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "getOutstandingOnboardingActionsNum_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v3 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "getOutstandingOnboardingActionsNum_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v2 /*: any*/, v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }],
          "type": "Node",
          "abstractKey": "__isNode"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "46281cf941d0f3a0f285e5edec78b3d1c5c1f0a8399a5d802f793685e46ee2cf",
      "metadata": {},
      "name": "getOutstandingOnboardingActionsNum_Query",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "521d7530d7ae3d8876d3440d993ea1f8";
export default node;